export interface LogMsgCategory {
    runId: string,
    taskId: string,
    logNumber: number,
    totalCount: number,
    updated: string,
}

export interface LogMsg {
    uid: string,
    projId: string,
    taskId: string,
    runId: string,
    created: string,
    updated: string,
    logNumber: number,
    logInfo: string,
}

export interface LogDisplay {
    logNumber: number,
    logTime: string,
    logModule: string,
    logType: string,
    logContent: string,
}

export interface ErrLogMsgCategory {
    runId: string,
    taskId: string,
    totalCount: number,
    updated: string,
}

export interface ErrLogMsg {
    uid: string,
    projId: string,
    taskId: string,
    runId: string,
    created: string,
    updated: string,
    toolName: string,
    content: string,
}

export const logLevelFilter = [
    { text: 'ERROR', value: "ERROR" },
    { text: 'INFO', value: "INFO" },
    { text: 'WARN', value: "WARN" },
    { text: 'SUCCESS', value: "SUCCE" },
]